'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions(date, mealType, excludedDates, recipe, servings, synchWithGoogle) {
  this.oN = null;
  this.ro = null;
  this.wO = null;
  this.rp = null;
  this.sS = 0;
  this.sT = false;
  this.oN = date;
  this.ro = mealType;
  this.wO = excludedDates;
  this.rp = recipe;
  this.sS = servings;
  this.sT = synchWithGoogle;
}
export { $c_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions as $c_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions };
$p = $c_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions;
/** @constructor */
function $h_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions() {
}
export { $h_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions as $h_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions };
$h_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (-1923335489));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.oN));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.ro));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.wO));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.rp));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.sS);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.sT ? 1231 : 1237));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 6);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions)) {
    if (((this.sS === x$0.sS) && (this.sT === x$0.sT))) {
      var x = this.oN;
      var x$2 = x$0.oN;
      var $x_3 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.ro;
      var x$4 = x$0.ro;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.wO;
      var x$6 = x$0.wO;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.rp;
      var x$8 = x$0.rp;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 6;
});
$p.r = (function() {
  return "ScheduleDialogOptions";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.oN;
      break;
    }
    case 1: {
      return this.ro;
      break;
    }
    case 2: {
      return this.wO;
      break;
    }
    case 3: {
      return this.rp;
      break;
    }
    case 4: {
      return this.sS;
      break;
    }
    case 5: {
      return this.sT;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kC)));
}
export { $isArrayOf_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions as $isArrayOf_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions };
var $d_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions, "mealorama.pages.RecipeListPage$ScheduleDialogOptions", ({
  kC: 1,
  Lu: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions as $d_Lmealorama_pages_RecipeListPage$ScheduleDialogOptions };
//# sourceMappingURL=mealorama.pages.-Recipe-List-Page$-Schedule-Dialog-Options.js.map
